var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ThankYouHero',{attrs:{"header":"FORGOT PASSWORD","paragraph":"Request received! If your email address is associated with an existing Sun Heroes account, you will receive an email with a link to reset your password shortly.","image":"Super-Steph-SunHero-300-V1","sunheroClass":"sunheroimage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }